import { Table, TableContainer } from "@mui/material";
import { useSelector } from "react-redux";

import EnchanedFilterTableHeader from "./EnchanedFilterTableHeader";
import TableService from "./TableService";
import NoDataFound from "../NoDataFound/NoDataFound";
import ActivityIndicator from "./ActivityIndicator";

export default function Datatable({onChangeFilter, data, columns, isLoading, themeType, onChangeSort}) {
  return (
    <>
    <TableContainer 
    sx={{borderRadius:'8px'}}>
      <Table>
        <EnchanedFilterTableHeader
          onChangeFilter={onChangeFilter}
          columns={columns}
          themeType={themeType}
          onChangeSort={onChangeSort}
        />
        <TableService
          rows={data}
          columns={columns}
        />
      </Table>
    </TableContainer>
    {data.length <= 0 && !isLoading && <NoDataFound />}
    {data.length <= 0 && isLoading && <ActivityIndicator />}
    </>
  );
}
